import { panel, rangeSlider } from 'instantsearch.js/es/widgets';
import { facetHeaderTemplate } from '../templates/facetsTemplate';

export const initRangeSlider = () => {
	const rangeSliderTargetDiv = document.querySelector('#rangeSlider');
	const { currency } = rangeSliderTargetDiv.dataset;

	const priceRangeSlider = panel({
		hidden(options) {
			return options.results.nbHits === 0;
		},
		collapsed: () => false,
		templates: {
			header(options, { html }) {
				return facetHeaderTemplate(
					html,
					options.widgetParams.attribute,
					currency,
				);
			},
		},
		cssClasses: {
			root: 'ais-Panel--rangeSlider',
		},
	})(rangeSlider);

	return priceRangeSlider({
		container: rangeSliderTargetDiv,
		attribute: 'price.priceValue',
		pips: false,
	});
};
